




















import { IDialog } from "@/lib/interfaces/dialog.interface";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import FleetManagerTree from "./FleetManagerTree.vue";

@Component({
  components: {
    FleetManagerTree
  }
})
export default class FleetManagerTreeDialog extends Vue implements IDialog {
  isDialog = false;

  open(): void {
    this.isDialog = true;
  }

  close(): void {
    this.isDialog = false;
  }

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds;
  }

  set selectedFleetIds(selected: string[]) {
    FleetManagerModule.setSelectedFleetIds(selected);
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  applySelection() {
    this.$emit("confirm");
    this.isDialog = false;
  }
}
